



















































import { Vue, Component } from 'vue-property-decorator';
import { SwipeItem, Swipe } from 'vant';
import Banner from '@/components/Banner.vue';
import BottomTabbar from '@/components/BottomTabbar.vue';
import * as config from '../config';
import { getCollegeList, topNewsList } from '../api/index';
Vue.use(SwipeItem).use(Swipe);

@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class College extends Vue {
  option = config.OPTHINES;
  newsList: any[] = [];
  bannerSrc = require('../assets/banner.png');
  collegeData: any[] = [];
  currentTitle: string = '';
  created() {
    this.fetchCollegeList();
    this.fetchTopNews();
  }

  async fetchCollegeList() {
    const ret = await getCollegeList();
    this.collegeData = ret.data;
    sessionStorage.setItem('CM-CollegeList', JSON.stringify(ret.data));
  }
  async fetchTopNews() {
    const res = await topNewsList();
    this.newsList = res.data;
    this.currentTitle = this.newsList[0].title;
  }
  handleJump(url: string) {
    window.location.href = url;
  }
  handleSwipeChange(index: number) {
    this.currentTitle = this.newsList[index].title;
  }
  handleClickItem(id: string, title: string) {
    this.$router.push({
      path: 'CollegeWork',
      query: {
        id,
        title,
      },
    });
  }
  toNewsList() {
    this.$router.push({
      path: 'news-list',
    });
  }

  jumpLink(link: string) {
    window.location.href = link;
  }
}
